module.exports = __webpack_public_path__ + "img/503media.4859951e.png";